import { call, put, takeLatest } from 'redux-saga/effects';
import { createFlashMessage } from '../components/Flash/redux';
import { getEmailLogs, exportEmailLogs } from '../utils/api/admin';
import { actionTypes } from './action-types';

function* fetchEmailLogsSaga({ payload }) {
  try {
    const data = yield call(getEmailLogs, payload);
    yield put({ type: actionTypes.fetchEmailLogsComplete, payload: data });
  } catch (error) {
    console.error('Error fetching email logs:', error);
    yield put({ type: actionTypes.fetchEmailLogsError, payload: error });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Erro ao buscar logs de email.',
        variables: { dismissible: true }
      })
    );
  }
}

function* exportEmailLogsSaga({ payload }) {
  let blobUrl = null;

  try {
    const { blob, limitApplied } = yield call(exportEmailLogs, payload);

    const fileName = `relatorio-emails-enviados_${
      new Date().toISOString().split('T')[0]
    }.xlsx`;

    blobUrl = globalThis.window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    yield put({ type: actionTypes.exportEmailLogsComplete });

    if (limitApplied) {
      yield put(
        createFlashMessage({
          type: 'info',
          message: 'Exportação limitada a 5.000 registros mais recentes.',
          variables: { dismissible: true }
        })
      );
    }
  } catch (error) {
    console.error('Error exporting email logs:', error);
    yield put({ type: actionTypes.exportEmailLogsError, payload: error });
    yield put(
      createFlashMessage({
        type: 'danger',
        message: 'Erro ao exportar logs de email.',
        variables: { dismissible: true }
      })
    );
  } finally {
    // Sempre limpar o blob URL para prevenir memory leak
    if (blobUrl) {
      globalThis.window.URL.revokeObjectURL(blobUrl);
    }
  }
}

export function createEmailLogsSaga(types) {
  return [
    takeLatest(types.fetchEmailLogs, fetchEmailLogsSaga),
    takeLatest(types.exportEmailLogs, exportEmailLogsSaga)
  ];
}
